import { useEffect, useState } from "react";
import "./Bio.css";
import JoaoCarvalho from "../../assets/bio/me.png";
import JoaoCarvalhoSurfing from "../../assets/bio/mesurfer.png";
import SurfingMan from "../../assets/bio/surfing.gif";
import SocialMedias from "../../components/SocialMedias";

const Bio = () => {
  const [currentPicture, setCurrentPicture] = useState(JoaoCarvalho);
  const [nextPicture, setNextPicture] = useState(JoaoCarvalhoSurfing);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentPicture(nextPicture);
      setNextPicture(currentPicture);
    }, 15000);

    return () => clearInterval(interval);
  }, [currentPicture, nextPicture]);

  return (
    <body id="bio" className="bio">
      <div className="mainBio">
        <div className="mainBioText">
          <h2 className="whoIam">Quem sou eu?</h2>
          <h1>João Carvalho "Dante"</h1>
          <div className="biographyText">
            <p>
              Sou um <b>Desenvolvedor Full Stack </b> que nasceu em uma ilha no
              nordeste do Brasil.
            </p>
            <p>
              Trabalho atualmente na <b> DBServer </b>e meu foco é sempre
              desenvolver tendo em mente o <b> desempenho </b> e a
              <b> interação amigável </b> com o user.
            </p>
            <p>
              No meu tempo livre faço projetos paralelos de programação, pratico
              esportes e me divirto com jogos online.
            </p>
          </div>
          <SocialMedias className="socialMedias" />
        </div>
        <div className="mainBioImg">
          <img
            className="bioPicture"
            src={currentPicture}
            alt="Imagem do autor - João Vitor Carvalho, utilizando gorro na cabeça e jaqueta azul"
          />
        </div>
      </div>
      <div className="bottonBio">
        <img src={SurfingMan} alt="Gif de um surfista em uma onda" />
        <div className="waveContinuation"></div>
      </div>
    </body>
  );
};

export default Bio;
